import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Deliberately unregister, not register. A service worker's own cache
// lives outside normal HTTP/browser caching and survives hard refreshes
// — during early production rollout that meant a fresh deploy (new API
// URL, new bundle hash, everything) kept getting masked by a stale
// cached response from a *previous* deploy, which is a much worse
// support problem for a storefront than the offline/installable
// behavior a service worker would have bought here.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
